// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-tip .el-dialog .el-dialog__body .dialog-input-container label{font-size:12px;color:#515151}.add-tip .el-dialog .el-dialog__body .dialog-input-container .el-input{width:250px}", ""]);
// Exports
module.exports = exports;
